import { FilterProps } from 'pages/EventLog/types/eventLog';
import { ProductionEventProps, OrderLinesProps } from 'types/productionEvent';
import { validArray } from 'utils';

export function checkActiveResendEvent(currentState:ProductionEventProps, event:ProductionEventProps) {
  function checkParent(matchEvent:ProductionEventProps) {
    // return currentState.orderInfo.id === matchEvent.orderInfo.id;
    return currentState.orderInfo ? currentState.orderInfo.id === matchEvent.orderInfo.id : false;
  }
  return event && checkParent(event);
}

export function checkActiveChildResendEvent(currentState:ProductionEventProps, childEvent: OrderLinesProps) {
  function checkChild(matchChildEvent:OrderLinesProps) {
    return childEvent.salesOrderLineId === matchChildEvent.salesOrderLineId;
  }
  return validArray(currentState.orderLines) && currentState.orderLines.some(checkChild);

}

export function getEventCellData(event:ProductionEventProps) {
  const { 
    orderInfo: {
      packSite, targetERP, targetSalesOrder,
    },
    customer: {
      shipTo: {
        locationId,
      },
    },
  } = event;
  return [
    {
      label: 'Location ID',
      value: locationId,
    },
    {
      label: 'Packsite',
      value: packSite,
    },
    {
      label: 'Target ERP',
      value: targetERP,
    },
    {
      label: 'Target SO',
      value: targetSalesOrder,
    },
  ]
}

export function getEventChildCellData(event:OrderLinesProps) {
  return [
    {
      label: 'Child Event ID',
      value: event.salesOrderLineId,
    },
    {
      label: 'Child Activity Type',
      value: event.purchaseOrderRef,
    },
  ]
}

export function getOrganisationIndex(orgRef: string, organisations:{ orgRef: string }[]) {
  function matchOrganisation(organisationToMatch:{ orgRef: string }) {
    return orgRef === organisationToMatch.orgRef;
  }
  return organisations.findIndex(matchOrganisation);
}

export function mutateEvent({
  event,
}:{
  event:ProductionEventProps,
}) {
  return {
    processingStatus: 'PROCESSING',
    targetSalesOrder: event.orderInfo.targetSalesOrder,
    errors: event.orderInfo.errors,
    dispatcherLineDetails: event.orderLines.map(item => ({
      packId: item.packId,
      processingStatus: 'PROCESSING',
      errors: item.errors,
    })),
  }
}

export function mutateDispatcherCloseEvent({
  event,
}:{
  event:ProductionEventProps,
}) {
  return {
    processingStatus: 'PROCESSED',
    targetSalesOrder: event.orderInfo.targetSalesOrder,
    errors: event.orderInfo.errors,
    dispatcherLineDetails: event.orderLines.map(item => ({
      packId: item.packId,
      processingStatus: 'PROCESSED',
      errors: item.errors,
      closureMessage: item.closureMessage,
      fullName: item.fullName,
      userId: item.userId,
    })),
  }
}

export function mutateFilters(filters: FilterProps) {
  const {
    // activityType,
    // date,
    // fromDate: stateFromDate,
    processingStatus,
    offSet,
    limit,
    // toDate: stateToDate,
  } = filters;
  // let fromDate;
  // let toDate;

  /* if (date === 'Past Day') {
    fromDate = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Past Week') {
    fromDate = moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Past Month') {
    fromDate = moment().subtract(1, 'month').add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Choose Dates') {
    fromDate = moment(stateFromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment(stateToDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
  } */

  return {
    // activityType: activityType === 'All' ? undefined : activityType.replace(/ /g, '_').toUpperCase(),
    // fromDate,
    // toDate,
    'processingStatus[in]': processingStatus && processingStatus.join(',').toUpperCase(),
    limit,
    offSet,
  }
}

export function setActionFill(disabled:boolean, actionActive:boolean) {
  if (disabled) {
    return 'warm-grey-200';
  }
  if (actionActive) {
    return 'white';
  }
  return 'black';
}

export function setBadgeType(status:string) {
  if (status && status.toUpperCase() === 'SUCCESS') {
    return 'success';
  }
  if (status && status.toUpperCase() === 'RESOLVED') {
    return 'info';
  }
  if (status && status.toUpperCase() === 'FAILED') {
    return 'error';
  }
  return 'warning';
}

export function setStatusFilters(status:string, currentState:string[]) {
  let newState = [...currentState];
  if (status === 'All' || (currentState.includes(status) && currentState.length === 1)) {
    return ['All'];
  }
  if (currentState.includes('All')) {
    return [status];
  }
  if (currentState.includes(status)) {
    newState = newState.filter(item => item !== status);
    return newState;
  }
  if ([...newState, status].length > 5) {
    return ['All'];
  }
  return [...newState, status];
}

export function sortByDate(
  { customer: dateA }:ProductionEventProps,
  { customer: dateB }: ProductionEventProps,
) {
  return Number(new Date(dateB.shipTo.deliveryDate)) - Number(new Date(dateA.shipTo.deliveryDate));
}

export function setResendEvent(currentState: ProductionEventProps, event: ProductionEventProps, childEvent: OrderLinesProps) {
  let newState: ProductionEventProps;
  
  function removeEvent(matchEvent:OrderLinesProps) {
    return matchEvent.salesOrderLineId !== childEvent.salesOrderLineId;
  }
  
  // On child Click
  if (childEvent) {
    if (checkActiveResendEvent(currentState, event)){
      newState = { ... currentState };
    } else if (currentState.orderInfo) {
      newState = { ... currentState };
      return newState;
    } else {
      newState = { ... event };
      newState.orderLines = [];
    }
    if (validArray(newState.orderLines) && checkActiveChildResendEvent(currentState, childEvent)) {
      newState.orderLines = [...newState.orderLines.filter(removeEvent)];
      if (newState.orderLines.length === 0) {
        // @ts-ignore
        newState = {};
      }
    } else {
      newState.orderLines = newState.orderLines ? [...newState.orderLines, childEvent] : [childEvent];
    }
  
  // On parent Click
  } else if (checkActiveResendEvent(currentState, event)){
    // @ts-ignore
    newState = {};
  } else if (currentState.orderInfo) {
    newState = { ... currentState };
    return newState;
  } else {
    newState = { ... event };
  }

  return newState;
}

export function mutateCloseEvent(event: ProductionEventProps, childEvent: OrderLinesProps, closureMessage: string, firstName: string, lastName: string, userId: number) {
  const newState = event;
  childEvent.closureMessage = closureMessage;
  childEvent.fullName = `${firstName} ${lastName}`;
  childEvent.userId = userId;
  newState.orderLines = [childEvent];
  return newState;
}

/* export function setChildResendEvent(event: OrderLinesProps, currentState: OrderLinesProps[]) {
  let newState = [];
  
  function removeEvent(matchEvent:OrderLinesProps) {
    return matchEvent.salesOrderLineId !== event.salesOrderLineId;
  }

  if (validArray(currentState) && checkActiveChildResendEvent(event, currentState)) {
    newState = [...currentState.filter(removeEvent)];
  } else {
    newState = [...currentState, event];
  }

  return newState;
} */
